class EditBoxLink extends HTMLElement {

    connectedCallback() {
        const bundleId = JSON.parse(this.getAttribute('data-bundleid'))[0]
        const variantId = this.getAttribute('data-variant-id')
        this.createDynamicEditLink(bundleId[1], variantId)
    }

    createDynamicEditLink(bundleId, variantId) {
        const linkElement = document.createElement('a')
        linkElement.setAttribute('href', `/pages/coffret-a-composer?bundleId=${bundleId}&variantId=${variantId}`)
        linkElement.textContent = window.location.href.includes('/en') ? "Edit" : "Modifier";
        this.insertAdjacentElement('afterbegin', linkElement)
    }
}

customElements.define('edit-box-link', EditBoxLink);